export default __webpack_public_path__ + "static/media/ss11.09c4cbd5.jpg";